/**
 * Stable CSS class names for E2E — Rule tab grid (table + dialog + pagination).
 */
export const RTG = {
    root: 'rule-tab-grid',
    tablePaper: 'rule-tab-grid__table-paper',
    table: 'rule-tab-grid__table',
    head: 'rule-tab-grid__head',
    headRow: 'rule-tab-grid__head-row',
    headCell: 'rule-tab-grid__head-cell',

    body: 'rule-tab-grid__body',
    row: 'rule-tab-grid__row',
    cell: 'rule-tab-grid__cell',
    cellId: 'rule-tab-grid__cell--id',
    cellTenant: 'rule-tab-grid__cell--tenant',
    cellRuleKey: 'rule-tab-grid__cell--rule-key',
    cellEffectiveDate: 'rule-tab-grid__cell--effective-date',
    cellCriteriaCount: 'rule-tab-grid__cell--criteria-count',
    cellActions: 'rule-tab-grid__cell--actions',

    criteriaChip: 'rule-tab-grid-input--chip-criteria',
    editButton: 'rule-tab-grid-input--button-edit',
    deleteButton: 'rule-tab-grid-input--button-delete',
    editIcon: 'rule-tab-grid__edit-icon',
    deleteIcon: 'rule-tab-grid__delete-icon',

    pagination: 'rule-tab-grid__pagination',

    detailsDialog: 'rule-tab-grid__details-dialog',
    detailsDialogTitle: 'rule-tab-grid__details-dialog-title',
    detailsDialogTitleLayout: 'rule-tab-grid__details-dialog-title-layout',
    detailsDialogTitleKey: 'rule-tab-grid__details-dialog-title-key',
    detailsDialogCloseButton: 'rule-tab-grid-input--button-dialog-close',
    detailsDialogCloseIcon: 'rule-tab-grid__details-dialog-close-icon',
    detailsDialogContent: 'rule-tab-grid__details-dialog-content',

    detailsTablePaper: 'rule-tab-grid__details-table-paper',
    detailsTable: 'rule-tab-grid__details-table',
    detailsHead: 'rule-tab-grid__details-head',
    detailsHeadRow: 'rule-tab-grid__details-head-row',
    detailsHeadCell: 'rule-tab-grid__details-head-cell',
    detailsBody: 'rule-tab-grid__details-body',
    detailsRow: 'rule-tab-grid__details-row',
    detailsCell: 'rule-tab-grid__details-cell',
} as const;

export const rtgCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

